import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  type MentionKinds,
  resolveKind,
} from "src/base-components/Chat/PromptBox/mentionContent";

type Props = {
  label: string;
  /** All tag attributes except `label`. */
  attrs: Record<string, string>;
  /** Per-kind config providing the icon. */
  kinds?: MentionKinds;
};

/**
 * Renders a reference as plain inline text with the kind's icon in front,
 * both in the editor and in sent messages. The chip rows above a message
 * use `ReferencePill` instead.
 */
export const InlineReference: React.FC<Props> = ({ label, attrs, kinds }) => {
  const icon = resolveKind(kinds, attrs.kind)?.icon;
  return (
    <span data-loc={attrs.id ? `reference-${attrs.id}` : undefined}>
      {icon && <FontAwesomeIcon className="mr-1" icon={icon} />}
      {label}
    </span>
  );
};
